let base;
let hotelType = domain.indexOf('localhost') !== -1
if(hotelType){
  console.log(hotelType,'url--------')
   // base = 'http://test.api.hotel.xinjngtech.com/'
   base ='http://localhost:8080/'
   
}else{
   base = window.location.protocol + '//' + (process.env.NODE_API_DOMAIN || window.location.host) + '/';
}

export default base;


// WEBPACK FOOTER //
// ./src/api/baseUrl.js